<template>
  <div class="cbr-root" :style="themePageStyle">
  <head>
    <meta charset="utf-8" /><title>FLOCKR | Post Buy Request</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="/assets/images/favicon.svg">
    <link href="/assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="/assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="/assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="/assets/css/custom.css" rel="stylesheet" type="text/css" />
  </head>
  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <nav class="cbr-topbar">
      <div class="container d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap:12px;">
          <back-button class="me-2" />
          <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" /></a>
          <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Post Buy Request</span>
        </div>
        <button class="btn btn-sm btn-outline-secondary" @click="$router.back()">Cancel</button>
      </div>
    </nav>

    <div class="container cbr-container">
      <div class="row justify-content-center">
        <div class="col-lg-7">

          <div class="cbr-card">
            <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-bullhorn-outline me-2"></i>What are you looking for?</h6>

            <div class="mb-3">
              <label class="cbr-label">Title <span class="text-danger">*</span></label>
              <input v-model="form.title" type="text" class="form-control cbr-input" placeholder="e.g. Looking for 50 Dorper Sheep" />
            </div>

            <div class="mb-3">
              <label class="cbr-label">Description</label>
              <textarea v-model="form.description" class="form-control cbr-input" rows="3" placeholder="Describe exactly what you need — age, health, purpose..."></textarea>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-md-6">
                <label class="cbr-label">Species <span class="text-danger">*</span></label>
                <select v-model="form.speciesId" class="form-select cbr-input" @change="onSpeciesChange">
                  <option value="">Select species...</option>
                  <option v-for="sp in speciesList" :key="sp.id" :value="sp.id">{{ sp.name }}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="cbr-label">Breed</label>
                <select v-model="form.breedId" class="form-select cbr-input">
                  <option value="">Any breed...</option>
                  <option v-for="br in breedsList" :key="br.id" :value="br.id">{{ br.name }}</option>
                </select>
              </div>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-md-4">
                <label class="cbr-label">Quantity Needed <span class="text-danger">*</span></label>
                <input v-model="form.quantityNeeded" type="number" class="form-control cbr-input" min="1" placeholder="e.g. 50" />
              </div>
              <div class="col-md-4">
                <label class="cbr-label">Sex Preference</label>
                <select v-model="form.sexPreference" class="form-select cbr-input">
                  <option value="any">Any</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div class="col-md-4">
                <label class="cbr-label">Price Type</label>
                <select v-model="form.priceType" class="form-select cbr-input">
                  <option value="per_unit">Per Unit</option>
                  <option value="per_kg">Per Kg</option>
                  <option value="total">Total</option>
                </select>
              </div>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-6">
                <label class="cbr-label">Min Weight (kg)</label>
                <input v-model="form.minWeightKg" type="number" step="0.1" class="form-control cbr-input" placeholder="e.g. 20" />
              </div>
              <div class="col-6">
                <label class="cbr-label">Max Weight (kg)</label>
                <input v-model="form.maxWeightKg" type="number" step="0.1" class="form-control cbr-input" placeholder="e.g. 40" />
              </div>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-6">
                <label class="cbr-label">Budget Min (KES)</label>
                <input v-model="form.budgetMin" type="number" class="form-control cbr-input" placeholder="e.g. 5000" />
              </div>
              <div class="col-6">
                <label class="cbr-label">Budget Max (KES)</label>
                <input v-model="form.budgetMax" type="number" class="form-control cbr-input" placeholder="e.g. 8000" />
              </div>
            </div>

            <div class="mb-3">
              <label class="cbr-label">Delivery Location</label>
              <input v-model="form.deliveryLocation" type="text" class="form-control cbr-input" placeholder="e.g. Nairobi, Dagoretti Market" />
            </div>

            <div class="mb-3">
              <label class="cbr-label">Needed By</label>
              <input v-model="form.neededBy" type="date" class="form-control cbr-input" />
            </div>
          </div>

          <div v-if="submitError" class="alert alert-danger mt-3" style="background:rgba(255,107,107,.1);border:1px solid rgba(255,107,107,.4);color:#e05555;font-size:13px;"><i class="mdi mdi-alert-circle me-1"></i> {{ submitError }}</div>

          <div class="d-flex gap-2 mt-3">
            <button class="btn btn-outline-secondary flex-fill" @click="$router.back()">Cancel</button>
            <button class="btn btn-warning flex-fill" @click="submit" :disabled="!canSubmit || submitting">
              <span v-if="submitting"><span class="spinner-border spinner-border-sm me-1"></span> Posting...</span>
              <span v-else><i class="mdi mdi-bullhorn me-1"></i> Post Buy Request</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
  </body>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
html[data-theme="light"] .cbr-topbar{background:rgba(255,255,255,.96)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .cbr-root{background:#F7F5F2!important}
html[data-theme="light"] .cbr-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .cbr-label{color:#555!important}
html[data-theme="light"] .cbr-input::placeholder{color:#999!important}
</style>
<style scoped>
.cbr-root{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh}
.cbr-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:rgba(10,10,10,.95)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.cbr-container{padding-top:80px;padding-bottom:60px}
.cbr-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:24px}
.cbr-label{font-size:13px;font-weight:600;color:#D4C9B8!important;margin-bottom:6px;display:block}
.cbr-input{background:var(--fm-bg2,#0F0F0F)!important;border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8)!important;border-radius:8px}
.cbr-input:focus{border-color:#BFA164;box-shadow:0 0 0 2px rgba(191,161,100,.15);background:var(--fm-bg2,#0F0F0F)!important;color:var(--fm-h,#F5F0E8)!important}
.cbr-input::placeholder{color:#4A4540!important}
.cbr-input option{background:var(--fm-bg1,#141414)!important;color:var(--fm-h,#F5F0E8)!important}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .cbr-container { padding-top: 70px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .cbr-card { padding: 16px !important; border-radius: 10px; }
  .cbr-input { font-size: 16px !important; padding: 10px 12px !important; }
  .cbr-label { font-size: 12px !important; margin-bottom: 4px !important; }
}
</style>
<script>
import { executeJson, flocker } from "@/api";
export default {
  name: "CreateBuyRequest",
  data(){return{
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
submitting:false,submitError:'',speciesList:[],breedsList:[],form:{title:'',description:'',speciesId:'',breedId:'',quantityNeeded:'',sexPreference:'any',priceType:'per_unit',minWeightKg:'',maxWeightKg:'',budgetMin:'',budgetMax:'',deliveryLocation:'',neededBy:''}}},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},
canSubmit(){return this.form.title&&this.form.speciesId&&this.form.quantityNeeded}},
  mounted(){
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
var u=sessionStorage.getItem('userId');if(!u){this.$router.push('/login');return}this.fetchSpecies()},
  methods:{
    async fetchSpecies(){try{var r=await executeJson({function:"getAnimalSpecies"},flocker);if(r.data.success)this.speciesList=r.data.data.species||[]}catch(e){console.error(e)}},
    async fetchBreeds(){if(!this.form.speciesId){this.breedsList=[];return}try{var r=await executeJson({function:"getAnimalBreeds",speciesId:this.form.speciesId},flocker);if(r.data.success)this.breedsList=r.data.data.breeds||[]}catch(e){console.error(e)}},
    onSpeciesChange(){this.form.breedId='';this.fetchBreeds()},
    async submit(){
      this.submitting=true;this.submitError='';
      var p={function:"createBuyRequest",buyerId:sessionStorage.getItem('userId'),title:this.form.title,description:this.form.description,speciesId:this.form.speciesId,quantityNeeded:this.form.quantityNeeded,sexPreference:this.form.sexPreference,priceType:this.form.priceType,deliveryLocation:this.form.deliveryLocation};
      if(this.form.breedId)p.breedId=this.form.breedId;
      if(this.form.minWeightKg)p.minWeightKg=this.form.minWeightKg;
      if(this.form.maxWeightKg)p.maxWeightKg=this.form.maxWeightKg;
      if(this.form.budgetMin)p.budgetMin=this.form.budgetMin;
      if(this.form.budgetMax)p.budgetMax=this.form.budgetMax;
      if(this.form.neededBy)p.neededBy=this.form.neededBy;
      try{var r=await executeJson(p,flocker);if(r.data.success){this.$router.push('/my-buy-requests')}else{this.submitError=r.data.message||'Failed to post.'}}catch(e){this.submitError='Something went wrong.'}
      this.submitting=false
    }
  }
};
</script>
